<template>
  <div class="row">
    <div
      v-if="isLoading"
      class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 rounded shimmeer-card"
      v-for="item in [1, 2, 3, 4, 5, 6, 7]"
      :key="item"
    >
      <CustomPlayerShimmer />
    </div>
    <!-- <div
      class="col-12"
      
    > -->

    <div
    v-else="!isLoading"
      v-if="filteredItems.length > 0 && !isLoading"
      class="col-12"
    >
      <div class="card p-4 mb-4">
        <alltags
          :tag="tags"
          @changeTag="changeTag"
        />
      </div>
      <draggable
        :list="filteredItems"
        class="row mt-4"
        :options="option"
        ghost-class="ghost"
        @change="handleUpdateOrder"
      >
        <div
          v-for="item in filteredItems"
          class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 rounded"
        >
          <itemContainer
            :item="item"
            :key="item.id"
            :item_image="item_image"
            @handleRemovedItem="handleRemovedItem"
            @handleMakeHighlight="handleMakeHighlight"
            @handleViewDetails="handleViewDetails"
          />
        </div>
      </draggable>
    </div>
    <div
      v-bind:class="[
        'alert alert-warning',
        { 'd-none': filteredItems.length > 0 || isLoading },
      ]"
      role="alert"
      v-else
    >
      No items found
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import itemContainer from './components/item-container.vue';
import alltags from './components/tags.vue';
import axios from 'axios';

import CustomPlayerShimmer from './components/custom-player-shimmer.vue';

export default {
  name: 'VideoCard',
  components: {
    draggable,
    itemContainer,
    alltags,
    CustomPlayerShimmer,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
    item_image: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      isLoading: true,
      filteredItems: [],

      option: {
        animation: 200,
        group: 'items',
        ghostClass: 'ghost',
      },
    };
  },
  mounted() {
    this.filteredItems = this.items;
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  },
  methods: {
    handleUpdateOrder(evt) {
      const url = '/creator/flix-playlist/order';
      const newOrder = {
        item: evt.moved.element,
        oldIndex: evt.moved.oldIndex,
        newIndex: evt.moved.newIndex,
      };
      axios
        .patch(url, newOrder)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    changeTag(tag) {
      if (tag) {
        if (tag == 'all') {
          this.filteredItems = this.items;
          return;
        }
        this.filteredItems = this.items.filter((item) =>
          item.tags.toLowerCase().includes(tag.toLowerCase()),
        );
      } else {
        this.filteredItems = this.items;
      }
    },

    handleRemovedItem(id) {
      this.filteredItems = this.filteredItems.filter((item) => item.id != id);
      window.location.reload();
    },

    handleMakeHighlight(item) {
      const url = '/creator/video-item-highlight/' + item;
      axios
        .post(url, {
          isAjax: true,
        })
        .then((response) => {
          var currentId = this.filteredItems.find((x) => x.id == item);
          currentId.highlight = response.data.highlighted;
          notify('success', response.data.message);
        })
        .catch((error) => {
          notify('error', 'Something went wrong');
          console.error(error);
        });
    },

    handleViewDetails(item_id) {
      const url = `/creator/flix-playlist/${item_id}/edit-item`;

      window.location = url;
      return;
    },
  },
};
</script>

<style scoped>
.ghost {
  opacity: 0.5;
}

.alert {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 20px;
  margin-right: 20px;
  padding: 20px;
  border-radius: 10px;
  background-color: rgba(22, 24, 35, 0.06);
  color: rgb(22, 24, 35);
  font-size: 16px !important;
  font-weight: 600;
  text-transform: capitalize;
  align-items: center;
  display: flex;
  justify-content: center;
}
.shimmeer-card {
  height: 500px;
}
.shimmeer-card-tag {
  height: 100px;
  margin: 7px;
  padding: 13px;
}
.h-1 {
  height: 40px;
}
</style>
